module.exports = __webpack_public_path__ + "static/img/mss-2.02617a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mss/mss-2.png
// module id = tDLN
// module chunks = 1